/* External */
import {
  memo, useEffect, useRef,
} from 'react';
import QRCode from 'qrcode';
import PropTypes from 'prop-types';

/* Utils */
import { noOp } from '../../utils/functions';

/* Styles */
import './QrCode.scss';

function QrCode({ data, onError, className }) {
  const canvasEl = useRef();
  const containerEl = useRef();

  useEffect(() => {
    const width = containerEl.current.clientWidth;
    QRCode.toCanvas(
      canvasEl.current,
      data,
      { width },
      (err) => {
        if (err) onError(err);
      },
    );
  }, [onError, data]);

  return (
    <div
      ref={containerEl}
      className={`dtv-html5-c-qr-code ${className}`}
    >
      <canvas ref={canvasEl} className="dtv-html5-c-qr-code__canvas" />
    </div>
  );
}

QrCode.defaultProps = {
  onError: noOp,
  className: '',
};

QrCode.propTypes = {
  data: PropTypes.string.isRequired,
  onError: PropTypes.func,
  className: PropTypes.string,
};

export default memo(QrCode);
